import { Button, Input, Select } from "antd";
import React, { useState } from "react";
import PropTypes from "prop-types";
// import TextArea from "antd/es/input/TextArea";

AssignGrade.propTypes = {
  allGrades: PropTypes.array,
  sendQCResponse: PropTypes.func,
  setGradeModal: PropTypes.func,
  radiologist: PropTypes.object,
  study_info_model_id: PropTypes.string,
  gradeModal: PropTypes.object,
  status: PropTypes.string,
};

function AssignGrade({
  allGrades,
  sendQCResponse,
  radiologist,
  setGradeModal,
  study_info_model_id,
  gradeModal,
  status,
}) {
  const [selectedGrade, setSelectedGrade] = useState();
  // const [isFeedbackRequested, setIsFeedbackRequested] = useState(false);
  const [feedbackText, setFeedbackText] = useState("");
  const [remark, setRemark] = useState("");
  const [gradeError, setGradeError] = useState(false); // State to track grade error

  console.log(status);

  const handleGradeSelection = (value) => {
    setSelectedGrade(value);
    setRemark("");
    setGradeError(false); // Reset error when a grade is selected
  };

  const handleSubmit = () => {
    if (!selectedGrade && gradeModal.grade) {
      setGradeError(true); // Show error if grade not selected
      return;
    }

    sendQCResponse(
      gradeModal.status,
      study_info_model_id,
      radiologist,
      selectedGrade,
      feedbackText,
      remark
    );

    setGradeModal({
      radiologist: {},
      study_info_model_id: "",
      isModalOpen: false,
    });
  };

  return (
    <>
      {gradeModal.grade ? (
        <>
          <div
            style={{
              border: "1px solid rgb(217, 217, 217)",
              borderRadius: "8px",
              padding: "16px",
              backgroundColor: "rgb(249, 249, 249)",
              marginTop: "20px",
              display: "flex",
              justifyContent: "space-between",
            }}
          >
            <div className="my-2">
              <Select
                placeholder="Select a grade"
                value={selectedGrade}
                onChange={handleGradeSelection}
                style={{ width: "150px" }}
              >
                {allGrades.map((grade) => (
                  <Select.Option key={grade.id} value={grade.id}>
                    {grade.name}
                  </Select.Option>
                ))}
              </Select>
              {gradeError && (
                <div style={{ color: "red", marginTop: "8px" }}>
                  Please select a grade.
                </div>
              )}
            </div>
            <div
              className="my-2 remark_textBox"
              style={{ width: "200px !important" }}
            >
              <Input.TextArea
                value={remark}
                onChange={(e) => setRemark(e.target.value)}
                autoSize={{ minRows: 1, maxRows: 4 }}
                placeholder="Provide your remark here..."
              />
            </div>
          </div>

          {/* Feedback checkbox */}
          {/* <div className="my-2">
            <Checkbox
              checked={isFeedbackRequested}
              onChange={(e) => setIsFeedbackRequested(e.target.checked)}
            >
              Do you want to give feedback?
            </Checkbox>
          </div> */}
          {/* {isFeedbackRequested && (
            <div
              className="my-2 remark_textBox"
              style={{ width: "200px !important" }}
            >
              <TextArea
                style={{ width: "200px !important" }}
                value={feedbackText}
                onChange={(e) => setFeedbackText(e.target.value)}
                autoSize={{ minRows: 1, maxRows: 4 }}
                placeholder="Provide your feedback here..."
              />
            </div>
          )} */}
        </>
      ) : (
        <div className="my-2 remark_textBox">
          <Input.TextArea
            style={{ width: "270px !important" }}
            // value={status == "final" ? feedbackText : remark}
            value={feedbackText}
            onChange={(e) => setFeedbackText(e.target.value)}
            autoSize={{ minRows: 1, maxRows: 4 }}
            placeholder={"Provide your revise reason here..."}
          />
        </div>
      )}

      {/* Submit button */}
      <div className="d-flex justify-content-end my-2">
        <Button type="primary" onClick={handleSubmit}>
          Submit
        </Button>
      </div>
    </>
  );
}

export default AssignGrade;
